<template>
  <base-page-layout title="Consultar benefícios">
    <mf-button label="Voltar" color="marca-0-l40" icon="arrow_back" icon-position="left" text @click="goBack" />
    <div class="d-flex flex-column justify-center align-center my-2 mx-4">
      <span class="gray-title ma-2">Voucher - Zé Compensa</span>
      <span class="gray-subtitle mx-3">Selecione o CPF ou CNPJ do consumidor que deseja consultar.</span>

      <form class="d-flex flex-column ma-6 responsive-width">
        <label class="cinza-0-text">Documento consumidor</label>
        <v-text-field
          v-model="consumer"
          v-mask="inputMask"
          class="mt-1"
          :error-messages="consumerErrors"
          :placeholder="consumerPlaceholder"
          required
          outlined
          append-icon="search"
          background-color="white"
          @keydown.enter="submit"
          @input="$v.consumer.$touch()"
          @blur="$v.consumer.$touch()"
        />

        <mf-button
          class="align-self-center responsive-button"
          :disabled="disabledSubmit"
          color="marca-0-l40"
          label="Buscar"
          icon="arrow_forward"
          icon-position="right"
          @click="submit"
        />
      </form>
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    consumer: '',
  }),
  computed: {
    consumerErrors() {
      const errors = []
      if (!this.$v.consumer.$dirty) return errors
      !this.$v.consumer.required && errors.push('Preencha o campo com CPF ou CNPJ.')
      !this.$v.consumer.minLength && errors.push('CPF ou CNPJ inválido.')
      return errors
    },
    inputMask() {
      return ['###.###.###-##', '##.###.###/####-##']
    },
    consumerPlaceholder() {
      return 'CPF ou CNPJ'
    },
    disabledSubmit() {
      if (this.$v.$invalid) return true
      return false
    },
  },
  mounted() {
    if (!this.$getAllowedModules()['ze_delivery']) {
      this.goBack()
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'consultar-ofertas' })
    },
    invalidInput() {
      let error = false
      this.$v.$touch()
      if (this.$v.$invalid) error = true
      return error
    },
    async submit() {
      if (this.invalidInput()) return
      this.goToResults()
    },
    onlyNumbers(string) {
      return string.replace(/\D/g, '')
    },
    goToResults() {
      this.$router.push({
        name: 'consultar-voucher-ze-resultado',
        params: {
          c: this.onlyNumbers(this.consumer),
        },
      })
    },
  },
  validations: {
    consumer: { required, minLength: minLength(11) },
  },
}
</script>

<style lang="scss" scoped>
.gray-title {
  color: $cinza-d20;
  font-size: 22px;
  line-height: 26.4px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  text-align: center;
}

.gray-subtitle {
  color: $cinza-d10;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.4px;
  text-align: center;
}

.cinza-0-text {
  color: $cinza-0;
}

.responsive-width {
  margin-top: 40px !important;
  width: 280px;
}

.responsive-button {
  margin-top: 40px !important;

  ::v-deep button {
    width: 180px !important;
  }
}

@media screen and (max-width: 933px) {
  .responsive-width {
    margin-top: 64px !important;
    width: 100%;
  }

  .responsive-button {
    margin-top: 64px !important;

    ::v-deep button {
      width: 240px !important;
    }
  }
}
</style>
